import { Paragraph } from "@twilio-paste/core/paragraph";
import { Button } from "@twilio-paste/core/button";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalFooterActions,
  ModalHeader,
  ModalHeading,
} from "@twilio-paste/core/modal";
import chatService from "../../../../../../services/conversations/conversationsService";
import { useNavigate } from "react-router-dom";

import { copy } from "./definitions";
import { SubmitTicketActionProps } from "./definitions";

const SubmitTicketModalConfirmationAction = (
  props: SubmitTicketActionProps
) => {
  const navigate = useNavigate();
  const { setIsModalOpen, isModalOpen, action } = props;
  const modalHeadingID = "submit-ticket-modal-heading";

  const handleClose = () => setIsModalOpen(false);

  const handleConfirm = async () => {
    handleClose();
    await chatService.endLiveChat();
    navigate(`/submit?${action?.params}`);
  };

  return (
    <Modal
      ariaLabelledby={modalHeadingID}
      isOpen={isModalOpen}
      onDismiss={handleClose}
      size="default"
    >
      <ModalHeader>
        <ModalHeading as="h3" id={modalHeadingID}>
          {copy.modal.header}
        </ModalHeading>
      </ModalHeader>
      <ModalBody>
        <Paragraph>{copy.modal.body}</Paragraph>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActions>
          <Button variant="secondary" onClick={handleClose}>
            {copy.modal.actions.close}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {copy.modal.actions.confirm}
          </Button>
        </ModalFooterActions>
      </ModalFooter>
    </Modal>
  );
};

export default SubmitTicketModalConfirmationAction;
